import React, { Component } from 'react';
import { Col, Card, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';


class PhysicalExam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: "",
            weight: "",
            abdominalPerimeter: "",
            size: "",
            heartRate: "",
            breathingFrequency: "",
            temperature: "",
            bloodPressure: "",
            BMI: "",
            bodySurface: "",
            age: '',
            load: false
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Col>
                <Card body outline color="secondary">
                <div className="card__title">
                            <h5 className="bold-text">Examen Físico</h5>
                        </div>
                    <div className="form" style={{ flex: 1 }}>                       
                        <div className="form__half">
                            <div className="form__form-group">
                                <span className="form__form-group-label">Aspectos Generales</span>
                                <div className="form__form-group-field">
                                    <textarea
                                        name="generalFeatures" rows="10" cols="50"
                                        defaultValue={this.props.data.generalFeatures}
                                        onChange={(e) => { this.props.handlerPhysicalExam('generalFeatures', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Cabeza y cara</span>
                                <div className="form__form-group-field">
                                    <textarea
                                        name="headAndFace" rows="10" cols="50"
                                        defaultValue={this.props.data.headAndFace}
                                        onChange={(e) => { this.props.handlerPhysicalExam('headAndFace', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>

                            <div className="form__form-group">
                                <span className="form__form-group-label">Otorrino</span>
                                <div className="form__form-group-field">
                                    <textarea
                                        name="ori" rows="10" cols="50" defaultValue={this.props.data.ori}
                                        onChange={(e) => { this.props.handlerPhysicalExam('ori', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Ojos</span>
                                <div className="form__form-group-field">
                                    <textarea
                                        name="eyes" rows="10" cols="50" defaultValue={this.props.data.eyes}
                                        onChange={(e) => { this.props.handlerPhysicalExam('eyes', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Cuello</span>
                                <div className="form__form-group-field">
                                    <textarea name="neck" rows="10" cols="50" defaultValue={this.props.data.neck}
                                        onChange={(e) => { this.props.handlerPhysicalExam('neck', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Toráx</span>
                                <div className="form__form-group-field">
                                    <textarea name="chest" rows="10" cols="50" defaultValue={this.props.data.chest}
                                        onChange={(e) => { this.props.handlerPhysicalExam('chest', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Cardiovascular</span>
                                <div className="form__form-group-field">
                                    <textarea name="cardioVascular" rows="10" cols="50"
                                        defaultValue={this.props.data.cardioVascular}
                                        onChange={(e) => { this.props.handlerPhysicalExam('cardioVascular', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        <div className="form__half">
                            <div className="form__form-group">
                                <span className="form__form-group-label">Pulmonar</span>
                                <div className="form__form-group-field">
                                    <textarea name="pulmonary" rows="10" cols="50"
                                        defaultValue={this.props.data.pulmonary}
                                        onChange={(e) => { this.props.handlerPhysicalExam('pulmonary', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Abdomen</span>
                                <div className="form__form-group-field">
                                    <textarea name="abdomen" rows="10" cols="50" defaultValue={this.props.data.abdomen}
                                        onChange={(e) => { this.props.handlerPhysicalExam('abdomen', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Extremidades</span>
                                <div className="form__form-group-field">
                                    <textarea name="limbs" rows="10" cols="50" defaultValue={this.props.data.limbs}
                                        onChange={(e) => { this.props.handlerPhysicalExam('limbs', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Neurologico</span>
                                <div className="form__form-group-field">
                                    <textarea name="neurological" rows="10" cols="50"
                                        defaultValue={this.props.data.neurological}
                                        onChange={(e) => { this.props.handlerPhysicalExam('neurological', e.target.value) }}>

                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Genitourinario</span>
                                <div className="form__form-group-field">
                                    <textarea name="genitourinary" rows="10" cols="50"
                                        defaultValue={this.props.data.genitourinary}
                                        onChange={(e) => { this.props.handlerPhysicalExam('genitourinary', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Piel Faneras</span>
                                <div className="form__form-group-field">
                                    <textarea name="skin_appendages" rows="10" cols="50"
                                        defaultValue={this.props.data.skin_appendages}
                                        onChange={(e) => { this.props.handlerPhysicalExam('skin_appendages', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span className="form__form-group-label">Otorrino</span>
                                <div className="form__form-group-field">
                                    <textarea name="skin_appendages" rows="10" cols="50"
                                        defaultValue={this.props.data.otorrino}
                                        onChange={(e) => { this.props.handlerPhysicalExam('otorrino', e.target.value) }}>
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </Col>)
    }

}


export default reduxForm({
    form: `physical-exam-form`, // a unique identifier for this form
})(withTranslation('common')(PhysicalExam));

